import { FlowsQuestion } from '../../../../../types/FlowsTypes';
import useAvailableIndices from './useAvailableIndices';
import useTableColumns, { TableColumn } from './useTableColumns';

export interface TableRow {
  index: number;
  columns: TableColumn[];
}

const useTableItemObjects = (question: FlowsQuestion): TableRow[] => {
  const tableColumns = useTableColumns(question);
  const availableIndices = useAvailableIndices(question);

  return availableIndices.map((index) => ({
    index: index || 0,
    columns: tableColumns,
  }));
};

export default useTableItemObjects;
